export default {"loader":"Brteh","mulShdSpin":"lwujL"};